import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer",
  class: "footer-area bg-footer"
}
const _hoisted_2 = { class: "footer-top" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row lgRow" }
const _hoisted_5 = { class: "col-lg-2 col-md-6 smallRow" }
const _hoisted_6 = { class: "footer-list ml-50" }
const _hoisted_7 = { class: "col-lg-2 col-md-6 smallRow" }
const _hoisted_8 = { class: "footer-list ml-20" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[14] || (_cache[14] = _createElementVNode("h3", { "data-lang": "foot.product.title" }, null, -1)),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      "data-lang": "menu.sms",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.goToOtp && $options.goToOtp(...args)))
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.gotoVoice && $options.gotoVoice(...args))),
                      "data-lang": "menu.voice"
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = (...args) => ($options.goToNumber && $options.goToNumber(...args))),
                      "data-lang": "menu.phone"
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = (...args) => ($options.gotoEmail && $options.gotoEmail(...args))),
                      "data-lang": "menu.emailHome"
                    })
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("li", null, [
                    _createElementVNode("i", { class: "bx bxs-chevron-right" }),
                    _createElementVNode("a", { href: "https://docs-yoni-tech.readme.io/reference/whatsapp_message-send" }, " WhatsApp")
                  ], -1)),
                  _createElementVNode("li", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = (...args) => ($options.gotoEsim && $options.gotoEsim(...args)))
                    }, "ESIM")
                  ])
                ])
              ])
            ]),
            _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"col-lg-2 col-md-6 smallRow\"><div class=\"footer-list ml-50\"><h3 data-lang=\"foot.developer.title\"></h3><ul><li><i class=\"bx bxs-chevron-right\"></i><a href=\"https://docs-yoni-tech.readme.io/reference/summary\" data-lang=\"foot.developer.developer1\"></a></li></ul></div></div>", 1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", { "data-lang": "foot.company.title" }, null, -1)),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = (...args) => ($options.goToAbout && $options.goToAbout(...args))),
                      "data-lang": "foot.company.title3"
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = (...args) => ($options.gotoTerm && $options.gotoTerm(...args))),
                      "data-lang": "foot.developer.developer3"
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bx bxs-chevron-right" }, null, -1)),
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = (...args) => ($options.gotoPrivacyPolicy && $options.gotoPrivacyPolicy(...args))),
                      "data-lang": "foot.developer.developer4"
                    })
                  ])
                ])
              ])
            ]),
            _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"col-lg-3 col-md-6 smallRow\"><div class=\"footer-list ml-20\"><h3>Contact Us</h3><ul><li><i class=\"bx bxs-chevron-right\"></i><a>service@yoni-tech.com</a></li></ul></div></div><div class=\"footerImg col-md-4\"><div class=\"footer-single-content\"><a><img src=\"static/image/wechat.jpg\" alt=\"Logo\"></a><p data-lang=\"menu.wechat\"></p></div></div><div class=\"footerImg col-md-4\"><div class=\"footer-single-content\"><a href=\"\"><img src=\"static/image/LinkedIn.png\" alt=\"Logo\"></a><p data-lang=\"menu.LinkedIn\"></p></div></div><div class=\"footerImg col-md-4\"><div class=\"footer-single-content\"><a href=\"\"><img src=\"static/image/facebook.png\" alt=\"Logo\"></a><p data-lang=\"menu.facebook\"></p></div></div>", 4))
          ])
        ])
      ])
    ])
  ]))
}